 <template>
  <div class="address-cell-wrapper">
    <span
      v-if="row.mls_floor_plan_feature && row.mls_floor_plan_feature.preview"
      @click.stop.prevent="onPreviewPdf"
      class="address-link"
      title="Click to preview PDF"
    >
      {{ row.mls_address }}
    </span>

    <span :title="row.mls_address" v-else class="address-text">{{ row.mls_address || '-' }}</span>

    <b-button
    v-if="!isMobile"
      variant="light"
      size="sm"
      @click.stop="onViewHistory"
      title="View History"
      class="history-btn-custom"
    >
      <i class="fa fa-history"></i> History
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    row: { type: Object, required: true }
  },
  methods: {
    onPreviewPdf() {
      this.$emit('preview-pdf', this.row.mls_floor_plan_feature);
    },
    onViewHistory() {
      this.$emit('view-history', this.row);
    }
  },
  computed: {
    isMobile() {
       if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 500) {
                return true
            } else {
                return false
            }
    },
  }
}
</script>

<style scoped>
.address-cell-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}
.address-link {
  color: #0b36dc;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}
.address-link:hover {
  color: #0056b3;
}
.address-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}
.history-btn-custom {
  font-size: 11px !important;
  padding: 2px 5px !important;
}
</style>
